import Vue from 'vue';
import Vuex from 'vuex';

import eventManager from '@/store/modules/eventManager';
import shop from '@/extensions/shop/store/modules/shop';
import currentPage from '@/store/modules/currentPage';
import setup from '@/store/modules/setup';
import auth from '@/store/modules/auth';

// install Vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    modules: {
        // CMS, // global
        setup, // global
        currentPage, // namespaced
        eventManager, // namespaced
        shop, // namespaced
        auth // namespaced
    },
    strict: debug
});

export default store;
